<div class="back-to-list">
  <div class="navigation-left">
    <a class="arrow arrow-left" (click)="goBack()">{{ backToLabel }}</a>
  </div>
</div>
<form [formGroup]="form" (ngSubmit)="save()">
  <mat-card>
    <mat-card-title>{{ 'parameters/custom-events/details/title' | translate }}</mat-card-title>
    <mat-card-content>
      <div class="warning" *ngIf="create">
        <mat-icon> info_outline </mat-icon>&nbsp;
        <span translate="parameters/custom-events/details/warning"></span>
      </div>

      <p>
        <mat-form-field class="w-100">
          <mat-label translate="parameters/custom-events/details/name"></mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
      </p>

      <p>
        <mat-form-field class="w-100">
          <mat-label translate="parameters/custom-events/details/description"></mat-label>
          <input matInput formControlName="description" />
        </mat-form-field>
      </p>

      <p>
        <app-select
          [control]="form.get('type')"
          [items]="customEventTypes"
          [labelKey]="'parameters/custom-events/details/type'"></app-select>
      </p>
    </mat-card-content>
    <mat-card-actions *ngIf="form.enabled">
      <button
        type="submit"
        mat-raised-button
        color="primary"
        [disabled]="form.get('name').invalid"
        translate="save"></button>
      <button type="button" mat-raised-button translate="cancel" (click)="goBack()"></button>
    </mat-card-actions>

    <app-card-footer [data]="footerContent"></app-card-footer>
  </mat-card>
</form>
